import React from "react";

import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import "./home-page.css";
import MarketingFooter from "./components/MarketingFooter";
import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";

export default function Contatti() {
  

  const [errors, setErrors] = React.useState({});
  const [success, setSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

const form = e.currentTarget;
const formData = new FormData(form);

const nome = String(formData.get("nome") || "").trim();
const telefono = String(formData.get("telefono") || "").trim();
const confermaTelefono = String(
  formData.get("confermaTelefono") || ""
).trim();
const email = String(formData.get("email") || "").trim();
const confermaEmail = String(formData.get("confermaEmail") || "").trim();
const provincia = String(formData.get("provincia") || "").trim();
const locale = String(formData.get("locale") || "").trim();
const messaggio = String(formData.get("messaggio") || "").trim();

    setErrors({});
    setSuccess(false);

    const newErrors = {};

    if (nome.length < 2) {
  newErrors.nome = "Inserisci il tuo nome";
}

const telefonoPulito = telefono.replace(/\s+/g, "");
const confermaTelefonoPulito = confermaTelefono.replace(/\s+/g, "");

if (telefonoPulito.length < 6) {
  newErrors.telefono = "Numero di telefono non valido";
}

    if (email !== confermaEmail) {
      newErrors.email = "Le email non coincidono";
      newErrors.confermaEmail = "Le email non coincidono";
    }

if (
  telefonoPulito.length >= 6 &&
  telefonoPulito !== confermaTelefonoPulito
) {
  newErrors.telefono = "I numeri non coincidono";
  newErrors.confermaTelefono = "I numeri non coincidono";
}

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      newErrors.email = "Email non valida";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(db, "mail"), {
        to: "info@qrmenu-italia.it",
        message: {
          subject: "Nuova richiesta contatto QrMenu",
          text: `
Nuova richiesta contatto QrMenu

Nome: ${nome}
Telefono: ${telefonoPulito}
Email: ${email}
Provincia: ${provincia || "Non indicata"}
Locale: ${locale || "Non indicato"}
Messaggio: ${messaggio || "Nessun messaggio inserito"}
          `.trim()
        },
        createdAt: serverTimestamp()
      });

      form.reset();
      setSuccess(true);
        setErrors({});
    } catch (err) {
      console.error(err);
        setErrors({ general: "Errore invio. Riprova tra poco." });
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home-pro">

      <SEO
  title="Contatti | QrMenu Italia"
  description="Contatta QrMenu Italia per informazioni sul menu digitale QR con AI per ristoranti, pizzerie e locali."
  canonical="https://qrmenu-italia.it/contatti"
  image="https://qrmenu-italia.it/logo512.png"
  keywords="contatti qrmenu, informazioni qrmenu"
/>

      <MarketingNavbar />

      <section className="hp-final" style={{ minHeight: "100vh" }}>
        <div className="hp-final-inner">
          <div className="contact-heading">
  <span className="contact-eyebrow">Contattaci</span>

  <h1 className="hp-final-h2">
    Parliamo del tuo locale
  </h1>

  <p className="hp-final-sub">
    Raccontaci cosa ti serve. Ti ricontatteremo per mostrarti
    come QrMenu può adattarsi al tuo locale.
  </p>

  <div className="contact-benefits">
    <span>✓ Nessun impegno</span>
    <span>✓ Configurazione personalizzata</span>
    <span>✓ Supporto diretto</span>
  </div>
</div>

<form className="contact-form" onSubmit={handleSubmit}>
  <div className="contact-field">
    <label htmlFor="contact-nome">Nome e cognome</label>

    <input
      id="contact-nome"
      name="nome"
      type="text"
      placeholder="Come ti chiami?"
      className={`contact-input ${errors.nome ? "error" : ""}`}
      autoComplete="name"
      required
    />

    {errors.nome && (
      <span className="input-error">{errors.nome}</span>
    )}
  </div>

  <div className="contact-field">
    <label htmlFor="contact-telefono">Telefono</label>

    <input
      id="contact-telefono"
      name="telefono"
      type="tel"
      placeholder="Il tuo numero di telefono"
      className={`contact-input ${errors.telefono ? "error" : ""}`}
      autoComplete="tel"
      inputMode="tel"
      required
    />

    {errors.telefono && (
      <span className="input-error">{errors.telefono}</span>
    )}
  </div>

  <div className="contact-field">
    <label htmlFor="contact-conferma-telefono">
      Conferma telefono
    </label>

    <input
      id="contact-conferma-telefono"
      name="confermaTelefono"
      type="tel"
      placeholder="Ripeti il numero di telefono"
      className={`contact-input ${
        errors.confermaTelefono ? "error" : ""
      }`}
      autoComplete="off"
      inputMode="tel"
      required
    />

    {errors.confermaTelefono && (
      <span className="input-error">
        {errors.confermaTelefono}
      </span>
    )}
  </div>

  <div className="contact-field">
    <label htmlFor="contact-email">Email</label>

    <input
      id="contact-email"
      name="email"
      type="email"
      placeholder="La tua email"
      className={`contact-input ${errors.email ? "error" : ""}`}
      autoComplete="email"
      inputMode="email"
      required
    />

    {errors.email && (
      <span className="input-error">{errors.email}</span>
    )}
  </div>

  <div className="contact-field">
    <label htmlFor="contact-conferma-email">
      Conferma email
    </label>

    <input
      id="contact-conferma-email"
      name="confermaEmail"
      type="email"
      placeholder="Ripeti la tua email"
      className={`contact-input ${
        errors.confermaEmail ? "error" : ""
      }`}
      autoComplete="off"
      inputMode="email"
      required
    />

    {errors.confermaEmail && (
      <span className="input-error">
        {errors.confermaEmail}
      </span>
    )}
  </div>

  <div className="contact-field">
    <label htmlFor="contact-provincia">
      Provincia <span>opzionale</span>
    </label>

    <input
      id="contact-provincia"
      name="provincia"
      type="text"
      placeholder="Esempio: Ragusa"
      className="contact-input"
      autoComplete="address-level2"
    />
  </div>

  <div className="contact-field">
    <label htmlFor="contact-locale">
      Nome del locale <span>opzionale</span>
    </label>

    <input
      id="contact-locale"
      name="locale"
      type="text"
      placeholder="Come si chiama il tuo locale?"
      className="contact-input"
      autoComplete="organization"
    />
  </div>

  <div className="contact-field">
    <label htmlFor="contact-messaggio">
      Messaggio <span>opzionale</span>
    </label>

    <textarea
      id="contact-messaggio"
      name="messaggio"
      placeholder="Raccontaci brevemente cosa ti serve"
      className="contact-input contact-textarea"
      rows="5"
    />
  </div>

  <label className="contact-privacy">
    <input
      name="privacy"
      type="checkbox"
      required
    />

    <span>
      Ho letto e preso visione della{" "}
      <a
        href="/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
      .
    </span>
  </label>

  {errors.general && (
    <div className="contact-error-box" role="alert">
      <strong>Invio non riuscito</strong>
      <span>{errors.general}</span>
    </div>
  )}

  <button
    type="submit"
    className="hp-btn-primary hp-btn-xl contact-submit"
    disabled={loading}
  >
    {loading ? "Invio in corso..." : "Invia richiesta"}
    <span className="hp-btn-arrow">→</span>
  </button>
</form>


          {success && (
            <div className="contact-success-box">
              <strong>Richiesta inviata 🚀</strong>
              <span>
                Abbiamo ricevuto i tuoi dati. Ti contatteremo a breve.
              </span>
            </div>
          )}
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}